export const state = {
  token: localStorage.getItem("token") || null,
  profile: localStorage.getItem("profile") ? JSON.parse(localStorage.getItem("profile")) : {},
};

export const mutations = {
  INIT_TOKEN(state, payload) {
    state.token = payload;
  },
  INIT_PROFILE_DATA(state, payload) {
    localStorage.setItem("profile", JSON.stringify(payload));
    state.profile = payload;
  },
  INIT_LOGGED_USER_PERMISSIONS(state, payload) {
    localStorage.setItem("permissions", JSON.stringify(payload));
    state.permissions = payload;
  },
};

export const actions = {
  saveToken: ({ commit }, payload) => {
    localStorage.setItem("token", payload.token);
    commit("INIT_TOKEN", payload.token);
    commit("INIT_LOGGED_USER_PERMISSIONS", payload.permissions);
  },
  storeProfileData: ({ commit }, payload) => {
    commit("INIT_PROFILE_DATA", payload);
  },
};

export const getters = {
  getToken: (state) => state.token,
  getLoggedUser: (state) => state.profile,
};
